import { render, staticRenderFns } from "./QuoteFreightItemsSection.vue?vue&type=template&id=1ba9cda6&scoped=true&"
import script from "./QuoteFreightItemsSection.vue?vue&type=script&lang=ts&"
export * from "./QuoteFreightItemsSection.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFreightItemsSection.vue?vue&type=style&index=0&id=1ba9cda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9cda6",
  null
  
)

export default component.exports